import AboutIndependentTechnicalSurveying from './about-independent-technical-surveying';

export default AboutIndependentTechnicalSurveying;